/**
 * A code for the website itself (2026-10-23, the owner: "create a way the foldmycard.com can also
 * be scanned by a camera to log in to the website, something with a small square"): a QR code on
 * the front page and the sign-in page that opens FoldMyCard's sign-in on a phone. It carries only
 * the address - signing in on the phone is as ever, with the email and password. Not shown on a
 * phone or tablet, which is where it leads.
 */
import { useMemo } from 'react';
import { useSite } from './idle.tsx';
import { qrModules, qrPath } from './qr.ts';
import { t } from './strings.ts';

export function SiteCode() {
  const site = useSite();
  const url = `${site?.appUrl || location.origin}/signin`;
  const modules = useMemo(() => qrModules(url), [url]);
  const n = modules.length;
  return (
    <div className="site-code no-print">
      <svg viewBox={`0 0 ${n} ${n}`} role="img" aria-label={t('siteCodeLabel')} shapeRendering="crispEdges">
        <path d={qrPath(modules, 0, 0, n)} fill="#111" />
      </svg>
      <span>
        <strong>{t('siteCodeTitle')}</strong>
        <p>{t('siteCodeText')}</p>
      </span>
    </div>
  );
}
